import React from "react";
import {useCookies} from "react-cookie";
import { Button, Grid } from "@mui/material";

const HomePage = () => {
  const [cookies] = useCookies([]);
  React.useEffect(() => {
    console.log(cookies)
  },[cookies])
  return(
    <Grid>
      <Button href="/ajouter-titre">Ajouter un projet</Button>
    </Grid>
  )
}

export default HomePage;